// import React, { useState } from 'react';
// import LogoSection from './LogoSection';
// import CROAdminNav from './CROAdminNav';
// import SponsorNav from './SponsorNav';
// import PINav from './PINav';
// import DataManagerNav from './DataManagerNav';
// import UserSection from './UserSection';
// import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
// // import { useSidebar } from '../Hooks/useSidebar';
// // import { useLogout } from '..Hooks/useLogout';
// import styles from './SideBar.module.css';
// import { useSidebar } from './Hooks/UseSidebar';
// import { useLogout } from './Hooks/UseLogout';

// const Sidebar = ({ isOpen, onToggle, isMobile }) => {
//     const {
//         user,
//         showUserMenu,
//         setShowUserMenu,
//         expandedSections,
//         toggleSection,
//         userMenuRef
//     } = useSidebar();

//     const { handleLogout } = useLogout();
//     const [showLogoutModal, setShowLogoutModal] = useState(false);

//     const userRoleName = user?.role?.roleName;
//     const isCROAdmin = userRoleName === 'CRO Administrator';
//     const isPIUser = userRoleName === 'Principal Investigator' || userRoleName === 'Co-ordinator member';
//     const isSponsor = userRoleName === "Sponsor";
//     const isDataManager = userRoleName === "Data Manager";

//     const handleNavClick = () => {
//         if (isMobile && isOpen) {
//             onToggle();
//         }
//     };

//     const getPortalInfo = () => {
//         if (isCROAdmin) return { title: 'CRO', subtitle: 'Portal', short: 'CRO' };
//         if (isSponsor) return { title: 'SP', subtitle: 'Portal', short: 'SP' };
//         if (isPIUser) return { title: 'PI', subtitle: 'Portal', short: 'PI' };
//         if (isDataManager) return { title: 'DM', subtitle: 'Portal', short: 'DM' };
//         return { title: 'CRO', subtitle: 'Portal', short: 'CRO' };
//     };

//     const handleLogoutClick = () => {
//         setShowUserMenu(false);
//         setShowLogoutModal(true);
//     };

//     const handleLogoutConfirm = async () => {
//         setShowLogoutModal(false);
//         await handleLogout();
//     };

//     const handleLogoutCancel = () => {
//         setShowLogoutModal(false);
//     };

//     const portalInfo = getPortalInfo();

//     return (
//         <>
//             <aside
//                 className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed} ${isMobile ? styles.mobile : ''}`}
//                 aria-label="Main navigation"
//             >
//                 <LogoSection isOpen={isOpen} portalInfo={portalInfo} />

//                 <nav className={styles.nav}>
//                     {isCROAdmin && (
//                         <CROAdminNav
//                             isOpen={isOpen}
//                             expandedSections={expandedSections}
//                             onToggleSection={toggleSection}
//                             onNavClick={handleNavClick}
//                         />
//                     )}

//                     {isSponsor && (
//                         <SponsorNav
//                             isOpen={isOpen}
//                             expandedSections={expandedSections}
//                             onToggleSection={toggleSection}
//                             onNavClick={handleNavClick}
//                         />
//                     )}

//                     {isPIUser && (
//                         <PINav
//                             isOpen={isOpen}
//                             expandedSections={expandedSections}
//                             onToggleSection={toggleSection}
//                             onNavClick={handleNavClick}
//                         />
//                     )}

//                     {isDataManager && (
//                         <DataManagerNav
//                             isOpen={isOpen}
//                             expandedSections={expandedSections}
//                             onToggleSection={toggleSection}
//                             onNavClick={handleNavClick}
//                         />
//                     )}
//                 </nav>

//                 <UserSection
//                     user={user}
//                     isOpen={isOpen}
//                     showUserMenu={showUserMenu}
//                     onToggleMenu={() => setShowUserMenu(!showUserMenu)}
//                     onLogoutClick={handleLogoutClick}
//                     userMenuRef={userMenuRef}
//                 />
//             </aside>

//             <ConfirmationModal
//                 show={showLogoutModal}
//                 title="Sign Out"
//                 message="Are you sure you want to sign out?"
//                 type="warning"
//                 confirmText="Sign Out"
//                 cancelText="Cancel"
//                 onConfirm={handleLogoutConfirm}
//                 onCancel={handleLogoutCancel}
//             />
//         </>
//     );
// };

// export default Sidebar;

import React, { useState, useEffect } from 'react';
import LogoSection from './LogoSection';
import CROAdminNav from './CROAdminNav';
import SponsorNav from './SponsorNav';
import PINav from './PINav';
import DataManagerNav from './DataManagerNav';
import UserSection from './UserSection';
import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
import styles from './SideBar.module.css';
import { useSidebar } from './Hooks/UseSidebar';
import { useLogout } from './Hooks/UseLogout';

const Sidebar = ({ isOpen, onToggle, isMobile }) => {
    const {
        user,
        showUserMenu,
        setShowUserMenu,
        expandedSections,
        toggleSection,
        userMenuRef
    } = useSidebar();

    const { handleLogout } = useLogout();
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    // Close user menu when sidebar closes on mobile
    useEffect(() => {
        if (isMobile && !isOpen) {
            setShowUserMenu(false);
        }
    }, [isOpen, isMobile, setShowUserMenu]);

    // Prevent body scroll on mobile when sidebar is open
    useEffect(() => {
        if (isMobile && isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobile, isOpen]);

    const userRoleName = user?.role?.roleName;
    const isCROAdmin = userRoleName === 'CRO Administrator';
    const isPIUser = userRoleName === 'Principal Investigator' || userRoleName === 'Co-ordinator member';
    const isSponsor = userRoleName === "Sponsor";
    const isDataManager = userRoleName === "Data Manager";

    const handleNavClick = () => {
        if (isMobile && isOpen) {
            onToggle();
        }
    };

    const getPortalInfo = () => {
        if (isCROAdmin) return { title: 'CRO', subtitle: 'Portal', short: 'CRO' };
        if (isSponsor) return { title: 'SP', subtitle: 'Portal', short: 'SP' };
        if (isPIUser) return { title: 'PI', subtitle: 'Portal', short: 'PI' };
        if (isDataManager) return { title: 'DM', subtitle: 'Portal', short: 'DM' };
        return { title: 'CRO', subtitle: 'Portal', short: 'CRO' };
    };

    const handleLogoutClick = () => {
        setShowUserMenu(false);
        setShowLogoutModal(true);
    };

    const handleLogoutConfirm = async () => {
        setShowLogoutModal(false);
        await handleLogout();
    };

    const handleLogoutCancel = () => {
        setShowLogoutModal(false);
    };

    const portalInfo = getPortalInfo();

    return (
        <>
            <aside
                className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed} ${isMobile ? styles.mobile : ''}`}
                aria-label="Main navigation"
                role="navigation"
            >
                <LogoSection isOpen={isOpen} portalInfo={portalInfo} />

                <nav className={styles.nav}>
                    {isCROAdmin && (
                        <CROAdminNav
                            isOpen={isOpen}
                            expandedSections={expandedSections}
                            onToggleSection={toggleSection}
                            onNavClick={handleNavClick}
                        />
                    )}

                    {isSponsor && (
                        <SponsorNav
                            isOpen={isOpen}
                            expandedSections={expandedSections}
                            onToggleSection={toggleSection}
                            onNavClick={handleNavClick}
                        />
                    )}

                    {isPIUser && (
                        <PINav
                            isOpen={isOpen}
                            expandedSections={expandedSections}
                            onToggleSection={toggleSection}
                            onNavClick={handleNavClick}
                        />
                    )}

                    {isDataManager && (
                        <DataManagerNav
                            isOpen={isOpen}
                            expandedSections={expandedSections}
                            onToggleSection={toggleSection}
                            onNavClick={handleNavClick}
                        />
                    )}
                </nav>

                <UserSection
                    user={user}
                    isOpen={isOpen}
                    showUserMenu={showUserMenu}
                    onToggleMenu={() => setShowUserMenu(!showUserMenu)}
                    onLogoutClick={handleLogoutClick}
                    userMenuRef={userMenuRef}
                />
            </aside>

            <ConfirmationModal
                show={showLogoutModal}
                title="Sign Out"
                message="Are you sure you want to sign out?"
                type="warning"
                confirmText="Sign Out"
                cancelText="Cancel"
                onConfirm={handleLogoutConfirm}
                onCancel={handleLogoutCancel}
            />
        </>
    );
};

export default Sidebar;
